import { render, staticRenderFns } from "./InfoTypeSeveritiesModal.vue?vue&type=template&id=18f4857d&"
import script from "./InfoTypeSeveritiesModal.vue?vue&type=script&lang=ts&"
export * from "./InfoTypeSeveritiesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports